/**
 * A single result box — the reusable "card" unit every diagnostic's
 * Results Page box-grid dashboard is built from.
 */
export const ResultBox = ({ children, className = "", testId, tone = "paper" }) => (
  <div
    data-testid={testId}
    className={`rounded-2xl p-6 md:p-8 ${
      tone === "dark" ? "bg-ink text-paper" : tone === "deep" ? "bg-paper-deep text-ink" : "bg-paper border border-ink/10 text-ink"
    } ${className}`}
  >
    {children}
  </div>
);

export default ResultBox;
